import { render, staticRenderFns } from "./ModalTentativaEntrega.vue?vue&type=template&id=6d150c04"
import script from "./ModalTentativaEntrega.vue?vue&type=script&lang=js"
export * from "./ModalTentativaEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports